import { getBodyAmplify } from './helpers';
import { API } from 'aws-amplify';

export const post = (path, data, name = 'EXAMPLE') =>
  API.post(process.env.REACT_APP_API_NAME, path, getBodyAmplify(data, name));

export const get = (path) =>
  API.get(process.env.REACT_APP_API_NAME, path, {
    response: true,
  });

export const patch = (path, data, name = 'EXAMPLE') =>
  API.patch(process.env.REACT_APP_API_NAME, path, getBodyAmplify(data, name));